import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-qr-page-not-found',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './qr-not-found.component.html',
    styleUrls: ['./qr-not-found.component.scss'],
    standalone: false
})
export class QRPageNotFoundComponent { }
